<template>
    <div class="goods_info">
        <header-section :subnav_show="false" :change_color="true" :cart_change="cart_change"></header-section>
        <!-- ======= Hero Section ======= -->
        <div id="hero-section" data-aos="zoom-out"></div>
  
        <!-- <div class="goods_info_top_mbx  width_center_1200">
            
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item v-for="(v,k) in goods_info.class_list" :key="k">{{v.name}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{goods_info.name}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div class="wrap">
      <div class="biger" id="biger"></div>
      <div class="imgs">
          <div class="main" id="main">
              <div class="mask" id="mask"></div>
          </div>
          <ul class="smaller" id="smaller"></ul>
      </div>
  </div>
        <div class="goods_info_top width_center_1200">
            <div class="goods_info_top_left" >
                <div class="goods_image_item">
                  <div id="magnifierId" @mousemove="move" @mouseout="end" @mouseover="start">
                      <img :src="goods_images_thumb[chose_img_pos]" id="img" />
                      <div id="Browser"></div>
                  </div>
                  <div id="magwrap">
                      <div id="mag"><img id="magnifierImg" /></div>
                  </div>
                  <!-- <pic-zoom :scale="2" :scroll="true" :url="goods_images_thumb[chose_img_pos]?goods_images_thumb[chose_img_pos]:''"></pic-zoom> -->
                </div>
                
                <div class="pic_zoom_list">
                    <div class="pic_zoom_list_left" @click="pre_img()">
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <ul>
                        <li v-for="(v,k) in goods_images_thumb" :key="k" @click="click_silde_img(k)" :class="chose_img_pos==k?'border_color':''"><img :src="v" alt=""></li>
                    </ul>
                    <div class="pic_zoom_list_right" @click="next_img()">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>
            <div class="goods_info_top_right" >
                <div class="goods_info_title">{{goods_info.name||'加载中...'}}
                    <p>{{goods_info.brief||'加载中...'}}</p>
                    <!-- <div :class="is_fav?'goods_info_sc red_color':'goods_info_sc'" @click="goods_fav()">{{is_fav?'已收藏':'收藏'}}<i class="icon iconfont">&#xe6cf;</i></div> -->
                </div>
                <div class="goods_info_group">
                    <!-- <div class="goods_info_price"><span>销售价：</span>{{goods_info.retailPrice||'0.00'}} 折</div> -->
                    <div class="goods_info_active"><span>编码：{{goodsSn}}</span></div>
                    <div class="goods_info_price"><span>售价：</span>提交询价->报价</div>
                    <div class="goods_info_active"><span>状态：</span>
                    <font :class="goods_info.isOnSale==true?'blue':'gray'">{{goods_info.isOnSale==true?'在售':'停售'}}</font>
                    <font :class="goods_info.isNew==true?'green':''" v-if="goods_info.isNew==true">新品</font>
                    <font :class="goods_info.isHot==true?'orange':''" v-if="goods_info.isHot==true">热卖</font> 
                    </div>
                    <!-- <div class="goods_info_market_price"><span>市场价：</span><div class="overx_goods_info"> 折{{goods_info.counterPrice||'0.00'}}</div></div> -->
                    <div class="goods_info_active"><span>优惠：</span>
                    
                    <!-- <font class="noy" v-if="goods_info.goods_freight<=0 && goods_info.freight_id<=0">包邮</font> -->
  
  <!--                        <font v-else-if="store_info.free_freight>0">满{{store_info.free_freight}}包邮</font>-->
                        <!-- <font class="noy" v-else>折扣优惠</font> -->
                        折扣优惠
                     </div>
                    <!-- <div class="goods_info_sale_num">累计销量<font color="#ca151e">{{goods_info.goods_sale_num}}</font></div>
                    <div class="goods_info_phone_read">手机查看<i class="icon iconfont">&#xeb9e;</i></div> -->
                </div>
                <!-- 参加活动 -->
                <!-- <div class="goods_info_active">
                    <div class="goods_skill" v-show="goods_info.is_seckill == 1">
                        <span><i class="icon iconfont">&#xe60c;</i></span>
                        <span>参加秒杀活动</span>
                        <span class="span_time">距离结束 {{seckill_hour}} 时 {{seckill_min}} 分 {{seckill_secs}} 秒</span>
                    </div>
                    <div class="goods_skill tuan_active" v-show="goods_info.is_groupbuy==1">
                        <span><i class="icon iconfont">&#xe8cc;</i></span>
                        <span>参加团购活动</span>
                        <span class="span_time">团购价：￥ {{goods_info.groupbuy_price}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 还差 {{goods_info.groupbuy_use}} / {{goods_info.groupbuy_num}} 人</span>
                    </div>
                </div> -->
                <div class="goods_info_spec" v-if="goods_info.sku_list&&goods_info.sku_list.length>0">
                    <div class="sku_list" v-for="(v,k) in goods_info.sku_list" :key="k">
                        <!-- <span v-for="(v1,k1) in JSON.parse(v.spData)" :key="k1">{{v1.key}}：{{v1.value}}</span> -->
                        <ul>
                            <li :class="(v.id==chose_sku_id)?'red':''" @click="attr_click(k, v)" style="cursor:pointer">
                                <!-- {{k==0?attr_click(k,v.id):''}} -->
                                {{Array.isArray(JSON.parse(v.spData)[0].value)?JSON.parse(v.spData)[0].value[k]:JSON.parse(v.spData)[0].value}}
                                <!-- <span v-for="(v1,k1) in JSON.parse(v.spData)[0].value" :key="k1">{{v1}}</span> -->
                                <!-- <span style="margin-left:10px" v-for="(v1,k1) in JSON.parse(v.spData)" :key="k1">{{v1.key}}：{{v1.value}}</span> -->
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="goods_info_num">
                    <div class="goods_info_num_title">购买数量：</div>
                    <div class="goods_info_num_jian" @click="change_buy_num(false)"><i class="el-icon-minus"></i></div>
                    <div class="goods_info_num_input"><input v-model="buy_num" type="text" value="1"></div>
                    <div class="goods_info_num_jia" @click="change_buy_num(true)"><i class="el-icon-plus"></i></div>
                    <div class="goods_info_num_stock">&nbsp;&nbsp;{{goodsStock}} 库存</div>
                    <div class="clear"></div>
                </div>
                <div class="goods_info_btn">
                    <!-- <div v-show="goods_info.is_groupbuy==1" class="goods_info_add_groupbuy" @click="group_buy()"><i class="icon iconfont">&#xe601;</i>选择团购</div>
                    <div :class="goods_info.isOnSale==true?'goods_info_buy':'goods_info_not_buy'" @click="buy()"><i class="icon iconfont">&#xe675;</i>立即下单</div> -->
                    <div :class="goods_info.isOnSale==true?'goods_info_add_cart':'goods_info_not_buy'" @click="add_cart()"><i class="icon iconfont">&#xe602;</i>加入询价车</div>
                </div>
  
            </div>
            <div class="clear"></div>
        </div>
        <!-- 详情 -->
        <div class="goods_info_text width_center_1200">
            <div class="goods_info_text_right">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="商品详情" name="first">
                        <div class="goods_attribute">
                            <ul v-show="attributes.length>0">
                                <li v-for="(v,k) in attributes" :key="k"><span>{{v.attribute}}</span> {{v.value}}</li>
                            </ul>
                        </div>
                        <div class="after_sale_content" v-html="goods_info.detail"></div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
      <!-- footer -->
      <footer-section></footer-section>
    </div>
  </template>
  
  <script>
  import StickyFill from 'stickyfilljs'
  import HeaderSection from "@/components/public/head.vue"
  import FooterSection from "@/components/public/footer.vue"
  import { _local } from "@/plugins/local-storage.js"
  //import leftSubjectRelationList from "@/components/home/public/left_subject_relation_list" // 相关推荐
  //import leftStoreInfoGoods from "@/components/home/store/left_store_info_goods"
  export default {
    components: {
        HeaderSection,
        FooterSection,
        //leftSubjectRelationList,// 相关推荐
        //leftStoreInfoGoods,
    },
    props: {},
    data() {
      return {
          activeName:'first',
          goods_id:0,   // 商品ID
          goods_info:{
              comment_num:0,
              goods_images_thumb_200:['~@/static/img/public/loading_pic_200.png']
          },
          store_info:{},
          buy_num:1, // 购买数量
          chose_sku_id:0,
          chose_spec:[], // 选择的规格属性
          chose_spec_info:{},
          attributes:[],//商品参数
          chose_img_pos:0,
          goods_images_thumb:['~@/static/img/public/loading_pic_400.png'],
          goods_images:[],
          comment_list:[], // 评论
          cart_change:0,
          is_fav:false,
          save_history:true, // 是否需要存储
        //   isSkeleton:false, // false 骨架显示
          comment_image:[],
  
          // 评论的东西
          total_data:0, // 总条数
          page_size:20,
          current_page:1,
          comment_type:0,//评论类型，如果是0则是商品评论，如果是1则是专题评论
          bfb:100,
          star:5.0,
          comment_num:{
              good:0,
              secondary:0,
              bad:0,
              all:0,
          },
  
          // 秒杀活动显示
          seckill_intvalobj:null,
          seckill_hour:0,
          seckill_min:0,
          seckill_secs:0,
          issues:[],
          pic_wrap: null,
          float_box: null,
          show: null,
          big_img: null,
          magnifier: null,
          doms: {
              cont : document.getElementById('magnifierId'),
              img : document.getElementById('magnifierImg'),
              mag : document.getElementById('mag'),
              scale : 3
          },
          goodsSn: '',  //商品编号
          goodsStock: '',  //商品库存
      };
    },
    watch: {
        // 监听选择购买数量
        buy_num:function(e){
            if(e>this.goods_info.goods_num || e<=0){
                if(this.goods_info.goods_num != 0){
                    this.$message.error('请填写购买数量');
                    this.buy_num = this.goods_info.goods_num;
                }
            }
        }
    },
    computed: {},
    updated(){
        const that = this
        that.init();
    },
    mounted() {
      document.body.style.overflow='';//出现滚动条
    },
    methods: {
      //动态修改浏览器标题
      setBrowserTitle(title) {
        document.title = title;
      },
      //动态添加meta标签 keywords content
      addMetaKeyWords (keywords) {
          //添加标题和meta标签
          let m = document.querySelectorAll('meta');
          for(let i=0;i<m.length;i++){
              if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
                  m[i].remove()
              }
          }
          const meta = document.createElement('meta')
          meta.name = 'keywords'
          meta.content = keywords
          m[m.length-1].after(meta)
      },
      init(){
              if(!('CSS'in window&&CSS.supports&&CSS.supports('position','sticky'))){
                  document.getElementById("magnifierId").setAttribute('style', 'left: 350px !important; top: 630px !important;')
                  document.getElementById("magwrap").setAttribute('style', 'left: 750px !important; top: 630px !important;width: 400px;height: 400px')
                  document.getElementById("mag").setAttribute('style', 'display: none;left: 0 !important; top: 0 !important;width: 400px;height: 400px')
                  const magnifier1 = document.getElementById('magnifierId');
                  const magwrap = document.getElementById('magwrap');
                  StickyFill.add(magwrap)
                  StickyFill.add(magnifier1);
              }
  
              this.cssTransfer(document.getElementById('magnifierImg'),{	
                  'position' : 'absolute',
                  'width' : (document.getElementById("magnifierId").clientWidth * this.doms.scale) + 'px',				//原始图像的宽*比例值	
                  'height' : (document.getElementById("magnifierId").clientHeight * this.doms.scale) + 'px'				//原始图像的高*比例值
                  })
              this.cssTransfer(document.getElementById('mag'),{
                  'display' : 'none',
                  'width' : document.getElementById("magnifierId").clientWidth + 'px',			//m.cont为原始图像,与原始图像等宽
                  'height' : document.getElementById("magnifierId").clientHeight + 'px',
                  // 'position' : 'absolute',
                  'left' : document.getElementById("magnifierId").offsetLeft + document.getElementById("magnifierId").offsetWidth + 10 + 'px',		//放大框的位置为原始图像的右方远10px
                  'top' : document.getElementById("magnifierId").offsetTop + 'px'
                  })
              
              var borderWid = document.querySelector("#Browser").offsetWidth - document.querySelector("#Browser").clientWidth;		//获取border的宽
              
              
              this.cssTransfer(document.querySelector("#Browser"),{			//document.querySelector("#Browser")为浏览框
                  'display' : 'none',								//开始设置为不可见
                  'width' : document.getElementById("magnifierId").clientWidth / this.doms.scale - borderWid + 'px',			//原始图片的宽/比例值 - border的宽度
                  'height' : document.getElementById("magnifierId").clientHeight / this.doms.scale - borderWid + 'px',		//原始图片的高/比例值 - border的宽度
                  'opacity' : 0.5					//设置透明度
                  })
                  
              document.getElementById('magnifierImg').src = document.querySelector("#img").src;			//让原始图像的src值给予放大图像
              document.getElementById("magnifierId").style.cursor = 'crosshair';
              
          },
      cssTransfer(elem,prop) {				//css设置函数,可以方便设置css值,并且兼容设置透明值
          for(var i in prop) {
              if(i == 'opacity') {
                  this.setOpacity(elem,prop[i]);
              } else {
                  elem.style[i] = prop[i];
              }
          }
          return elem;
      },
      getEventObject(W3CEvent) {			//事件标准化函数
          return W3CEvent || window.event;
      },
      getPointerPosition(e) {			//兼容浏览器的鼠标x,y获得函数
          e = e || this.getEventObject(e);
          var x = e.pageX || (e.clientX + (document.documentElement.scrollLeft || document.body.scrollLeft));
          var y = e.pageY || (e.clientY + (document.documentElement.scrollTop || document.body.scrollTop));
          
          return { 'x':x,'y':y };
      },
      setOpacity(elem,level) {			//兼容浏览器设置透明值
          if(elem.filters) {
              elem.style.filter = 'alpha(opacity=' + level * 100 + ')';
          } else {
              elem.style.opacity = level;
          }
      },
      start(){
          if(document.all){				//只在IE下执行,主要避免IE6的select无法覆盖
              this.createIframe(document.getElementById('magnifierImg'));
          }
      },
      move(e){
          
          document.getElementById('magnifierImg').src = document.querySelector("#img").src;
              var pos = this.getPointerPosition(e);		//事件标准化
  
              document.getElementById("Browser").style.display='';
              this.cssTransfer(document.getElementById("Browser"),{
                  'top' : Math.min(Math.max(pos.y - document.getElementById("magnifierId").offsetTop - parseInt(document.getElementById("Browser").style.height) / 2,0),document.getElementById("magnifierId").clientHeight - document.getElementById("Browser").offsetHeight) + 'px',
                  'left' : Math.min(Math.max(pos.x - document.getElementById("magnifierId").offsetLeft - parseInt(document.getElementById("Browser").style.width) / 2,0),document.getElementById("magnifierId").clientWidth - document.getElementById("Browser").offsetWidth) + 'px'			//left=鼠标x - this.offsetLeft - 浏览框宽/2,Math.max和Math.min让浏览框不会超出图像
              })
              document.getElementById('mag').style.display = '';
              
              this.cssTransfer(document.getElementById('magnifierImg'),{
                  'top' : - (parseInt(document.getElementById("Browser").style.top) * this.doms.scale) + 'px',
                  'left' : - (parseInt(document.getElementById("Browser").style.left) * this.doms.scale) + 'px'
              })
      },
          
          end:function(){
              document.getElementById("Browser").style.display = 'none';
              this.removeIframe(document.getElementById('magnifierImg'));		//销毁iframe
              
              document.getElementById('mag').style.display = 'none';
          },
          
          createIframe:function(elem){
              var layer = document.createElement('iframe');
              layer.tabIndex = '-1';
              layer.src = 'javascript:false;';
              elem.parentNode.appendChild(layer);
              
              layer.style.width = elem.offsetWidth + 'px';
              layer.style.height = elem.offsetHeight + 'px';
          },
          
          removeIframe:function(elem){
              var layers = elem.parentNode.getElementsByTagName('iframe');
              while(layers.length >0){
                  layers[0].parentNode.removeChild(layers[0]);
              }
          },
  
  
  
  
        handleClick:function(e){
            if(e.name == 'second'){
                this.current_page = 1;
                this.get_comment_list();
            }
        },
        current_change:function(e){
            this.current_page = e;
            this.get_comment_list();
        },
        get_comment_list:function(){
            this.$get(this.$api.getCommentList,{valueId:this.goods_id,type:this.comment_type,page:this.current_page,showType:0,limit:20}).then(res=>{
                // window.console.log(res);
                this.page_size = res.data.limit;
                this.total_data = res.data.total;
                this.current_page = res.data.page;
                this.comment_list = res.data.list;
                this.bfb = res.data.bfb;
                // this.star = res.data.star;
                this.comment_num = {good:res.data.good,secondary:res.data.secondary,bad:res.data.bad,all:res.data.all};
            });
        },
        // 点击缩略图幻灯片图片
        click_silde_img:function(e){
            this.chose_img_pos = e;
        },
        pre_img:function(){
            if(this.chose_img_pos<=0){
                this.chose_img_pos = this.goods_images.length-1;
            }else{
                this.chose_img_pos -= 1;
            }
        },
        next_img:function(){
            if(this.chose_img_pos>=this.goods_images.length-1){
                this.chose_img_pos = 0;
            }else{
                this.chose_img_pos += 1;
            }
        },
        // 购买数量修改
        change_buy_num:function(type){
            if(type){
                if(this.buy_num+1>this.goods_info.goods_num){
                    return this.$message.warning('请选择规格，或库存不足');
                }
                this.buy_num += 1;
            }else{
                if(this.buy_num<=1){
                    return this.$message.warning('产品至少选择一件');
                }
                this.buy_num -= 1
            }
        },
        // 收藏状态
        is_fav_fun:function(){
            if(this.$isEmpty(localStorage.getItem('token'))){
                return;
            }
            this.$post(this.$api.myIsFav,{mix_id:this.goods_id,is_type:0}).then(res=>{
                if(res.code== 200){
                    this.is_fav = true;
                }else{
                    this.is_fav = false;
                }
            });
        },
        goods_fav:function(){
            this.$post(this.$api.addordeleteFav,{valueId:this.goods_id,type:0}).then(()=>{
                this.is_fav = !this.is_fav;
                this.is_fav_fun();
            });
        },
        // 属性被选择点击
        attr_click:function(e,v){
            // this.goods_info.sku_list[e]['valueList'].forEach((res,key)=>{
            //     //res.is_chose = false;
            //     if(key == id){
            //         res.is_chose = true;
            //     }
            // });
            this.goodsSn = v.skuCode
            this.goodsStock = v.stock
            
            this.chose_sku_id = v.id;
            this.goods_info.chose_sku_id = v.id;
  
            this.goods_info.goods_num = this.goods_info.sku_list[e].stock;
            this.goods_info.retailPrice = this.goods_info.sku_list[e].price;
          //   this.goods_info.picUrl = this.goods_info.sku_list[e].picUrl;
            // this.buy_num = 1;
  
            // // 循环获取选择的规格属性
            // let chose_spec = [];
            // this.goods_info.sku_list.forEach(res=>{
            //     res['valueList'].forEach(listRes=>{
            //         if(!this.$isEmpty(listRes.is_chose) && listRes.is_chose == true){
            //             chose_spec.push(listRes.value);
            //         }
            //     });
            // });
            
            // this.chose_spec = chose_spec;
            // // window.console.log(this.chose_spec);
            // // 如果选择数量和规格数量一致则表示选择完所有的规格属性
            // if(this.chose_spec.length == this.goods_info.sku_list.length){
            //     this.get_spec_attr_data();
            // }
  
            // this.$forceUpdate();
        },
        // 根据选择的规格属性去获取数据库存在的规格数据
        get_spec_attr_data:function(){
             this.goods_info.chose_attr.forEach(res=>{
                let a = 0;
                this.chose_spec.forEach(specRes=>{
                    // let resInfo = res.spec_name.split(' ');
                    if(res.specifications.indexOf(specRes)>=0){
                        a += 1;
                    }
                });
                if(a == this.goods_info.sku_list.length){
                    this.chose_spec_info = res;
                    return this.change_goods_info();
                }
            });
        },
        change_goods_info:function(){
            this.goods_info.retailPrice = this.chose_spec_info.price;
            // this.goods_info.goods_market_price = this.chose_spec_info.goods_market_price;
            this.goods_info.goods_num = this.chose_spec_info.number;
        },
        // 如果是多规格产品则将商品价格取第一个规格产品
        // is_spec_goods:function(){
        //     if(!this.$isEmpty(this.goods_info.chose_attr)){
        //         this.goods_info.retailPrice = this.goods_info.chose_attr[0].price;
        //         // this.goods_info.goods_market_price = this.goods_info.spec[0].goods_market_price;
        //         this.goods_info.goods_num = this.goods_info.chose_attr[0].number;
        //     }
        // },
        // 立即购买
        buy:function(){
            if((typeof this.goods_info.chose_sku_id)==='undefined'){
                return this.$message.error('请选择规格型号');
            }
            let str = this.goods_info.id+'|'
                        // +this.goods_info.store_info.id
                        +'|'+this.buy_num;
            if(!this.$isEmpty(this.chose_spec_info['id']) && this.chose_spec_info['id']>0){
                str += '|'+this.chose_spec_info['id'];
            }
            
            this.goods_info['goodsId'] = this.goods_id;
            this.goods_info['productId'] = this.chose_sku_id;
            this.goods_info['number'] = this.buy_num;
            this.$post(this.$api.fastAddCart,this.goods_info).then(res=>{
                // window.console.log(res);
                if(res.errno == 0){
                    // this.get_goods_info();
                    this.cart_change += 1; // 修改购物车数据
                    this.$router.push("/order/create_order/0/"+str);
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        // 拼团购买
        group_buy:function(){
            if((typeof this.goods_info.chose_sku_id)==='undefined'){
                return this.$message.error('请选择规格型号');
            }
            let str = this.goods_info.id+'|'+this.goods_info.store_info.id+'|'+this.buy_num;
            if(!this.$isEmpty(this.chose_spec_info['id']) && this.chose_spec_info['id']>0){
                str += '|'+this.chose_spec_info['id'];
            }
            this.$router.push("/order/create_order/2/"+str);
        },
        // 加入购物车
        add_cart:function(){
            
            const userId=JSON.parse(_local.get('user_info'))&&JSON.parse(_local.get('user_info')).id?JSON.parse(_local.get('user_info')).id:'';
            if(!userId){
              this.$message.warning('请先登录，然后添加产品到购物车')
              this.$router.push('/user/login')
              return
            }
  
            if((typeof this.goods_info.chose_sku_id)==='undefined'){
                return this.$message.error('请先选择[规格、型号、版本]');
            }
            
            // if(this.chose_spec_info.length>0){
            //     this.goods_info['spec_id'] = this.chose_spec_info['id'];
            //     this.goods_info['goods_spec_name'] = this.chose_spec_info.spec_name;
            // }
            this.goods_info['goodsId'] = Number(this.goods_id);
          //   this.goods_info['productId'] = this.chose_sku_id;
            this.goods_info['checked'] = true
            this.goods_info['number'] = this.buy_num;
  
            this.goods_info['isInquiry'] = 1
            this.goods_info['goodsName'] = this.goods_info.name
          //   this.goods_info['skuId'] = this.goods_info.sku_list[0].id
            this.goods_info['deleted'] = 0
            delete this.goods_info['detail']
            delete this.goods_info['addTime']
            delete this.goods_info['attributeCategoryId']
            delete this.goods_info['sku_list']
            delete this.goods_info['purposeId']
            delete this.goods_info['shareUrl']
            delete this.goods_info['gallery']
            delete this.goods_info['addTime']
            delete this.goods_info['updateTime']
            delete this.goods_info['chose_attr']
            delete this.goods_info['categoryId']
            delete this.goods_info['chose_sku_id']
            this.goods_info['userId'] = userId
            this.goods_info['picUrl'] = this.goods_images_thumb[0]
  
            // 以下字段待定
            this.goods_info['specifications'] = ''
  
            const params ={
                  userId: JSON.parse(_local.get('user_info')).id,
                  cmsUserId: JSON.parse(_local.get('user_info')).id,
                  goodsName:this.goods_info.name,
                  goodsId:this.goods_info.id,
                  goodsType:this.goods_info.type,
                  goodsSn:this.goodsSn,
                  number:this.buy_num,
                  skuId:this.chose_sku_id,
                  checked:true
              }
            this.$post(this.$api.addCart,params).then(res=>{
                //window.console.log(res);
                if(res.code === 0){
                    this.get_goods_info();
                    this.cart_change += 1; // 修改购物车数据
                    return this.$message.success('加入购物车成功');
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        // 存储数据记录
        save_history_fun:function(goods_info){
            this.save_history=false;
            let goods_json = localStorage.getItem('shop_goods_historys');
            let goods_list = [];
  
            if(!this.$isEmpty(goods_json)){
                goods_list = JSON.parse(goods_json);
            }
            
            let have_his = false;
            if(goods_list.length>0){
                goods_list.forEach(res=>{
                    if(goods_info.id == res.id){
                        res.goods_name = goods_info.name;
                        res.image = goods_info.picUrl;
                        res.id = goods_info.id;
                        res.goods_price = goods_info.retailPrice;
                        have_his = true;
                    }
                })
            }
            
            if(!have_his){
                goods_list.push({id:goods_info.id,goods_name:goods_info.goods_name,goods_price:goods_info.goods_price,image:goods_info.goods_master_image});
            }
  
            if(goods_list.length>4){
                goods_list.splice(0,1);
            }
  
            let json_str = JSON.stringify(goods_list);
            localStorage.setItem('shop_goods_historys',json_str);
  
        },
        // 切换图片
        push_comment_images:function(e){
            this.comment_image = [];
            e.forEach(res=>{
                this.comment_image.push(res);
            });
        },
        // 查下评论状态
        change_comment_type:function(e){
            this.comment_type = e;
            this.get_comment_list();
        },
        // 活动开始定时任务  秒杀
        seckill_active:function(){
            this.seckill_intvalobj = setInterval(()=>{
            let end_time = this.goods_info.seckill_info.end_time;
            let timestamp = Date.parse(new Date())/1000;
            if(end_time>timestamp){
                let sec2 = end_time-timestamp;
                this.seckill_hour = Math.floor(sec2/3600);
                this.seckill_min = Math.floor((sec2-(this.seckill_hour*3600))/60);
                this.seckill_secs = sec2-(this.seckill_hour*60+this.seckill_min)*60;
            }else{
                this.goods_info.is_seckill = 0;
                clearInterval(this.seckill_intvalobj);
            }
        },1000);
        },
        // 获取商品信息
        get_goods_info:function(){
            
            this.goods_images_thumb = []
            this.goods_images = []
            this.goods_info.name = ''
            this.goods_info.brief = ''
            this.chose_sku_id = ''
  
            this.$get(this.$api.getProductDetail+'/'+this.goods_id).then(res=>{
                this.goods_info = res.data.product;
                //   this.goods_info.chose_attr = res.data.productList;
                //this.goods_info.sku_list = res.data.specificationList;
                this.goods_info.sku_list = res.data.skuStockList&&res.data.skuStockList.length>0?res.data.skuStockList:[];
  
              //   this.store_info = res.data.store_info;
                this.goods_images_thumb = [res.data.product.picUrl];
                this.goods_images = [res.data.product.picUrl];
                this.chose_sku_id = res.data.skuStockList&&res.data.skuStockList.length>0?res.data.skuStockList[0].id:''
                this.goods_info.chose_sku_id = res.data.skuStockList&&res.data.skuStockList.length>0?res.data.skuStockList[0].id:''
                this.goodsSn = res.data.skuStockList[0].skuCode
                this.goodsStock = res.data.skuStockList[0].stock
  
              //   this.attributes = res.data.attribute;
                this.buy_num = 1; // 初始化购买数量
                this.chose_spec = [];
                this.chose_spec_info = {};
                //this.is_spec_goods();
              //   this.issues = res.data.issue;
                //this.goods_info.comment_num = res.data.comment.count;
              //   this.is_fav =  res.data.userHasCollect==0?false:true;
         
                // this.isSkeleton = true; // 骨架显示
  
                // 存储游览记录
                if(this.save_history){
                    this.save_history_fun(this.goods_info);
                }
  
                // 数据获取成功则开始展示 秒杀活动信息
                if(this.goods_info.is_seckill == 1){
                    this.seckill_active();
                }
                if(res.data.groupon && res.data.groupon.length==1){
                    this.goods_info.is_groupbuy = 1;
                    this.goods_info.groupbuy_price = this.goods_info.retailPrice- res.data.groupon[0].discount;
                }
                this.setBrowserTitle(res.data.product.keywords)
                this.addMetaKeyWords(res.data.product.brief)
            });
        }
    },
    created() {
        this.goods_id = this.$route.params.goods_id;
        if(this.$isEmpty(this.goods_id)){
            return this.$message.error('请检查商品是否存在');
        }
        this.get_goods_info();
        // this.is_fav_fun();
    },
    beforeRouteUpdate(to, from, next) {
        this.goods_id = to.params.goods_id
        if(to.path != from.path){
            this.get_goods_info();
        }
  
        next()
    },
    beforeDestroy() {
      if(this.seckill_intvalobj){
          clearInterval(this.seckill_intvalobj)
          this.seckill_intvalobj = null
      }
    },
    destroyed(){
      document.title='河北科瑞达仪器科技股份有限公司-官方网站'
    }
  };
  </script>
  <style lang="scss" scoped>
  // 给富文本的内容表格添加边框
  /deep/ table {
      border-collapse: collapse;
  }
  /deep/ td {
      border: 1px solid #ccc;
      min-width: 50px;
      min-height: 30px;
      line-height: 20px;
      padding:5px 8px
  }
  /deep/ th {
      border: 1px solid #ccc;
      min-width: 50px;
      min-height: 30px;
      line-height: 20px;
      padding:5px 8px
  }
  /*--------------------------------------------------------------
  # Hero Section
  --------------------------------------------------------------*/
  .goods_info{
      overflow-x: hidden;
  }
  #hero-section {
      width: 100%;
      height: 45vh;
      background: url("~@/static/img/banner/product-banner.jpg");
      background-size: cover;
      position: relative;
  }
  .goods_info_top{
    background: #fbfbfb;
    width: 1200px;
    // padding:40px 0 60px 0;
    margin: 0 auto;
    margin-top: 60px;
    border-radius: 10px;
  }
  .goods_info_sc{
    background: #f6f6f6;
    border-radius: 6px;
    font-size: 14px;
    line-height: 25px;
    color:#666;
    position: absolute;
    top:0;
    right: 8px;
    padding:0 10px;
    i{
        margin-left: 6px;
        font-size: 12px;
    }
  }
  .goods_info_sc.red_color{
    color:#fff;
    background: #ca151e;
  }
  .goods_info_sc:hover{
    color:#fff;
    background: #ca151e;
  }
  .after_sale_content{
    font-size: 14px;
    ul{
        li{
            dt{
               color:#ca151e;
            }
        }
    }
  }
  .after_sale_content /deep/ img{vertical-align: text-bottom;}
  .goods_attribute{
    font-size: 14px;
    padding: 10px 0 10px;
    ul{
        li{
            width: 30%;
            float: left;
            margin-bottom:10px;
            span{font-size:14px;width: 200px; color: #666;}
        }
  
    }
  }
  .goods_info_spec{
    margin-top: 25px;
    padding-left:10px; 
    line-height: 25px;
    color:#666;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .sku_list{
        margin-bottom: 10px;
        span{float: left;}
        ul{
            float: left;
            li{
                float: left;
                color:#666;
                border:1px solid #e1e1e1;
                background-color: #e1e1e1;
                border-radius: 2px;
                font-size: 12px;
                padding: 0 8px;
                margin-right: 10px;
            }
            li.red{
                border:1px solid #0f56ff;
                background-color: #0f56ff;
                color:#ffffff;
                cursor: pointer;
            }
            li:hover{
                border:1px solid #0f56ff;
                background-color: #0f56ff;
                color:#eee;
            }
        }
    }
    :after{
        content:'';
        display: block;
        clear:both;
    }
  }
  .goods_info_text{
    background: #ffffff;
    width: 1200px;
    padding: 0 0 60px 0;
    margin: 0 auto;
    margin-top: 30px;
    border-radius: 10px;
    .goods_info_text_left{
        width: 234px;
        float: left;
        margin-left: 15px;
        margin-right: 15px;
    }
    .goods_info_text_right{
        margin-top: 20px;
        width: 100%;
        box-sizing: border-box;
        min-height: 600px;
        padding:20px;
        float: left;
        border:1px solid #efefef;
    }
  }
  /* :deep(.goods_info_text_right .el-tabs__item.is-active){
      color: #0f56ff
  }
  :deep(.goods_info_text_right .el-tabs__active-bar){
      background: #0f56ff;
  } */
  :deep(.goods_info_top_left .pic_zoom_list ul li.border_color){
      border-color: #0f56ff !important;
  }
  .goods_info_top_right{
    float: left;
    width: 770px;
    font-size: 14px;
    .goods_info_num{
        padding: 10px;
        margin-top: 10px;
        .goods_info_num_title{
            color:#666;
            float: left;
            line-height: 25px;
            margin-right: 15px;
        }
        .goods_info_num_jian,.goods_info_num_jia{
            border: 1px solid #0f56ff;
            background-color: #0f56ff;
            width: 25px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            float: left;
            margin-right: 10px;
            color:#ffffff;
            cursor: pointer;
        }
        .goods_info_num_stock{
            line-height: 25px;
            color:#999;
        }
        .goods_info_num_input{
            float: left;
        }
        .goods_info_num_input input{
            height: 27px;
            border:1px solid #efefef;
            outline: none;
            width: 50px;
            margin-right: 10px;
            box-sizing: border-box;
            padding: 0 8px;
            color:#666;
            text-align: center;
        }
    }
    .goods_info_btn{
        clear: both;
        margin: 20px auto auto 10px;
    }
    .goods_info_add_cart,.goods_info_buy{
        line-height: 40px;
        float: left;
        margin-right: 20px;
        background: #ca151e;
        border-radius: 3px;
        color:#fff;
        padding: 0 15px;
        cursor:pointer;
        i{
            margin-right: 6px;
        }
    }
    .goods_info_buy{
        background: #ca151e;
        i{
            font-size: 12px;
        }
    }
    .goods_info_add_cart,.goods_info_not_buy{
        line-height: 40px;
        float: left;
        margin-right: 20px;
        background: #0f56ff;
        border-radius: 3px;
        color:#fff;
        padding: 0 15px;
        i{
            margin-right: 6px;
        }
    }
    .goods_info_not_buy{
        background: #a9a9a9;
        i{
            font-size: 16px;
        }
    }
  
    .goods_info_add_groupbuy{
        line-height: 40px;
        float: left;
        margin-right: 20px;
        background: #67c23a;
        border-radius: 3px;
        color:#fff;
        padding: 0 15px;
        i{
            margin-right: 6px;
        }
    }
    
    .goods_info_title{
        position: relative;
        font-size: 18px;
        margin: 15px 0 10px 0;
        p{
            color:#999;
            line-height: 35px;
            font-size: 14px;
        }
    }
    .goods_info_group{
        position: relative;
        box-sizing: border-box;
        padding: 20px;
        // padding-bottom: 90px;
        width: 760px;
        height: 180px;
        background: url("~@/static/img/bg/summary-bg.jpg");
    }
    .goods_info_price{
        margin-top: 15px;
        color:#412702;
        font-size: 14px;
        line-height: 14px;
        span{
            line-height: 14px;
            color:#999;
            font-size: 14px;
        }
    }
    .goods_info_market_price{
        margin-top: 10px;
        span{
            color:#999;
        }
        .overx_goods_info{
            text-decoration: line-through;
            display: inline-block;
        }
    }
    .goods_info_sale_num{
        position:absolute;
        font-size: 12px;
        right: 16px;
        color:#333;
        top: 30px;
        font{
            margin-left: 10px;
            margin-right: 10px;
        }
    }
    .goods_info_phone_read{
        position:absolute;
        right: 24px;
        font-size: 12px;
        color:#999;
        top: 140px;
        i{
            margin-left: 10px;
            color:#666;
        }
    }
    
    .goods_info_active{
        margin-top: 10px;
        span{
            color:#999;
        }
        font{
            background: #ff6590;
            color:#fff;
            line-height: 34px;
            padding: 4px 8px;
            margin-right: 10px;
            border-radius: 3px;
        }
        font.noy{
            background: #0f56ff;
        }
        font.blue{
            background: #0f56ff;
        }
        font.orange{
            background: #f15b04;
        }
        font.green{
            background: #188d01;
        }
        font.gray{
            background: #6b6b6b;
        }
        font.noz{
            background: #0f56ff;
        }
        .goods_skill{
            margin-bottom: 10px;
            background: #fef0f0;
            border:1px solid  #fde2e2;
            font-size: 14px;
            span{
                color:#f56c6c;
                line-height: 40px;
                i{
                    font-size: 18px;
                    line-height: 40px;
                    margin-right: 20px;
                    margin-left: 20px;
                    float: left;
                }
            }
            span.span_time{
                float: right;
                margin-right: 30px;
            }
        }
        .tuan_active{
            background: #f0f9eb;
            border: 1px solid #e1f3d8;
            span{
                color:#67c23a;
            }
        }
    }
  }
  .goods_info_top_mbx{
    margin:30px auto;
  }
  .goods_info_top_left{
    width: 402px;
    border: 1px solid #efefef;
    margin-right: 28px;
    float: left;
    box-sizing: border-box;
    .goods_image_item{
        position: static !important;
        width: 400px;
        height: 400px;
        display: block;
        border-bottom: 1px solid #efefef;
    }
    .pic_zoom_list{
        ul li{
            float: left;
            margin:10px 10px 10px 0; 
            border:1px solid #efefef;
            img{
                width: 60px;
                height: 60px;
                display: block;
                object-fit: contain;
                object-position: center;
                background: #fff;
            }
        }
        ul li:hover{
            border-color:#ca151e;
        }
        ul li:last-child{
            margin-right: 0;
        }
        ul li.border_color{
            border-color:#ca151e;
        }
        .pic_zoom_list_left{
            font-size: 24px;
            float: left;
            line-height: 80px;
            color:#666;
            margin-right: 10px;
            margin-left: 10px;
            :hover{
                color:#ca151e;
            }
        }
        .pic_zoom_list_right{
            font-size: 24px;
            float: right;
            line-height: 80px;
            color:#666;
            margin-right: 10px;
            margin-left: 10px;
            :hover{
                color:#ca151e;
            }
        }
    }
  }
  /deep/ .after_sale_content{
      ul{
          padding: 10px 40px;
          list-style: disc;
          li{
              line-height: 25px;
              span{
                  position: relative;
                  top: 2px;
              }
          }
      }
  }
  </style>
  <style scoped>
  #magnifierId{
      width:400px !important;
      height:400px;
      position:sticky !important;
      top:630px !important;
      left:350px !important;
      font-size:0;
  }
  #magwrap{
      position: sticky !important;
      top: 0px !important;
      left: 0px !important;
      z-index: 99;
      width: 400px !important;
      height: 400px !important;
      object-fit: contain;
  }
  #img{
      width:400px;
      height:400px;
      display: block;
      object-fit: contain;
      object-position: center;
      background: #fff;
  }
  #magnifierImg{
      object-fit: contain;
      object-position: center;
  }
  #Browser{
      top:0;
      border:1px solid #000;
      z-index:100;
      position:absolute;
      background:#555;
  }
  #mag{
      position: absolute !important;
      top: -400px !important;
      left: 420px !important;
      overflow:hidden;
  }
  #magnifierId:hover #Browser{
      display: block !important;
  }
  </style>